import AppRoutes from "./AppRoutes";
import { LoadingProvider } from "./components/LoadingContext";

function App() {
  return (
    <LoadingProvider>
      <AppRoutes />
    </LoadingProvider>
  );
}

export default App;
